function convertirTableauxTemoins(xml, pathToDoc, actionTitle) {
	function createOriginalTable(index, element){
		originalTable.before(element);
	}

	var tableList = $("tablejs__table[outputclass='style_tableau-temoins5col']", xml);
	var previousTitle = "";
	for ( var tableIndex = 0; tableIndex < tableList.length ; tableIndex++ ) {
		var originalTable = $(tableList.get(tableIndex));
		var temoinsTable = new calsTable().load(originalTable);
		var htmlTable = temoinsTable.htmlTemoins(pathToDoc, actionTitle);
		var tempTitle = temoinsTable.getTextTemoinTitle().trim();
		if ( tempTitle !== previousTitle ) {
			var tableTitle = temoinsTable.getTemoinTitle();
			if ( previousTitle === "" ) {
				var pageTitle = $("div[data-role='content-body']", xml);
				pageTitle.attr('data-option-name', tempTitle);
				$("h1[data-role='content-title']", xml).append(tableTitle);
			} else {
				originalTable.before(tableTitle.get(0));
			}
			previousTitle = tempTitle;
		}
		htmlTable.each(createOriginalTable)
		originalTable.remove();
	}

	return xml;
}

function convertirTableauxTemoinseGuide(xml, pathToDoc) {
	function generateTemoinsTable(temoinsList) {
		if ( temoinsList.length > 0 ) {
			var firstTable = temoinsList[0]; // .clone()
			var topichref = $(firstTable).attr('data-topichref');
			if ( isHTMLtable(firstTable) ) {
				cleanEmptyRows(firstTable);
			} else {
				firstTable = new calsTable().load(firstTable).htmlTableTemoinseGuide(pathToDoc);
			}
			$("tr", firstTable).attr('data-topichref', topichref);
			for ( var index = 1; index < temoinsList.length; index++ ) {
				var currentTable = temoinsList[index];
				var topichref = $(currentTable).attr('data-topichref');
				if ( isTable(currentTable) ) {
					currentTable = new calsTable().load(currentTable).htmlTableTemoinseGuide(pathToDoc);
					$("tbody", firstTable).append($("tr", currentTable).attr('data-topichref', topichref));
				} else if ( isRelatedLinks(currentTable) ) {
					$("tbody", firstTable).append($("<tr/>").attr('data-topichref', topichref).append($("<td/>").attr('colspan', 5).attr('class', 'related-links-cell').append(currentTable.clone())));
					// $("tbody", firstTable).append($("tr").append($("td").attr('colspan', 5)).append(currentTable));
				}
				temoinsList[index].remove();
			}
		}
	}

	function cleanEmptyRows(table) {
		function isEmptyRow(element) {
			return ( $(element).text().trim().length == 0 );
		}

		$("tr", table).each(function (index, element) { if ( isEmptyRow(element) ) $(element).remove() });
	}

	function isHTMLtable(table) {
		return table.get(0).tagName.toLowerCase() == 'table';
	}

	function isTable(xmlFragment) {
		return xmlFragment.attr('outputclass') == 'style_tableau-temoins5col';
	}

	function isRelatedLinks(xmlFragment) {
		return xmlFragment.attr('data-role') == 'related-links-wrapper';
	}

	function isTableTemoins(tableList, tableIndex, temoinsListLength) {
		var currentTable = $(tableList.get(tableIndex));
		var nextTable = $(tableList.get(tableIndex + 1));
		return ( (currentTable.attr('outputclass') == 'style_tableau-temoins5col')
					|| ((temoinsListLength == 0) && (nextTable.attr('outputclass') == 'style_tableau-temoins5col'))
			);
	}

	function isRelatedLinksTemoins(tableList, tableIndex, temoinsListLength) {
		return ( ($(tableList.get(tableIndex)).attr('data-role') == 'related-links-wrapper')
					&& (temoinsListLength > 0) && (tableIndex > 0) && ($(tableList.get(tableIndex - 1)).attr('outputclass') == 'style_tableau-temoins5col')
			);
	}

	var tableList = $("tablejs__table[outputclass='style_tableau-temoins5col'], table, div[data-role='related-links-wrapper']", xml);
	var temoinsList = [];
	for ( var tableIndex = 0; tableIndex < tableList.length ; tableIndex++ ) {
		if ( isTableTemoins(tableList, tableIndex, temoinsList.length) ) {
			temoinsList.push($(tableList.get(tableIndex)));
		} else if ( isRelatedLinksTemoins(tableList, tableIndex, temoinsList.length) ) {
			temoinsList.push($(tableList.get(tableIndex)));
		} else if ( temoinsList.length > 0 ) {
			generateTemoinsTable(temoinsList);
			temoinsList = [];
			if ( isTableTemoins(tableList, tableIndex, temoinsList.length) ) {
				temoinsList.push($(tableList.get(tableIndex)));
			}
		}
	}
	generateTemoinsTable(temoinsList);

	return xml;
}

function calsTable() {
	this.table = [];
	this.cells = {};
	this.currentID = 0;
	this.tableTitle;
	this.stylesList = {'style_img-cligno-lent': 'clignotant_lent', 'style_img-cligno-rapide': 'clignotant_rapide', 'style_img-cligno-fixe': 'clignotant_then_fixe'};

	this.load = function(cals) {
		var tbody = $(cals).find('tablejs__tbody');
		var rows = $(tbody).find('tablejs__row');

		for ( var rowIndex = 0; rowIndex < rows.length; rowIndex++ ) {
			var row = rows.get(rowIndex);
			while ( (this.table.length - 1) < rowIndex )
					this.table.push([]);
			var entries = $(row).find('tablejs__entry');
			for ( var entryIndex = 0; entryIndex < entries.length; entryIndex++ ) {
				var entry = entries.get(entryIndex);
				var entryID = this.storeCell(this.currentID++, entry);
				var rowspan = parseInt($(entry).attr('morerows'));
				rowspan = Math.max(1, 1 + (isNaN(rowspan) ? 0 : rowspan));
				//var colspan = 1;
				var currentColPosition = this.table[rowIndex].indexOf(null);
				if ( currentColPosition < 0 ) currentColPosition = this.table[rowIndex].length;

				for ( var rowspanindex = 0; rowspanindex < rowspan; rowspanindex++ ) {
					while ( (this.table.length - 1) < (rowIndex + rowspanindex) )
						this.table.push([]);
					while ( (this.table[rowIndex + rowspanindex].length - 1) < (currentColPosition) )
						this.table[rowIndex + rowspanindex].push(null);
					this.table[rowIndex + rowspanindex][currentColPosition] = entryID;
				}
			}

		}

		return this;
	};

	this.storeCell = function(cellID, cellContent) {
		cellID = String(cellID);
		this.cells[cellID] = cellContent;

		return cellID;
	};

	this.getRawCell = function(cellID) {
		return $(this.cells[cellID]).clone();
	};

	this.getCellContent = function(cellID) {
		return $(this.cells[cellID]).children().clone();
	};

	this.getCellText = function(cellID) {
		return $(this.cells[cellID]).text();
	};

	this.htmlTable = function() {
		var htmlTable = $("<table/>").append("tbody");
		var workTable = this.arrayClone(this.table);
		for ( var rowIndex = 0; rowIndex < workTable.length; rowIndex++ ) {
			var row = workTable[rowIndex];
			var htmlRow = $("<tr/>");
			htmlTable.append(htmlRow);
			for ( var cellIndex = 0; cellIndex < row.length; cellIndex++ ) {
				var cellID = row[cellIndex];
				if ( cellID !== undefined ) {
					var htmlCell = $("<td/>");
					htmlRow.append(htmlCell);
					htmlCell.append(this.getRawCell(cellID));
					var colspan = 0;
					var rowspan = 0;
					while ( (cellIndex + colspan + 1 < row.length) && (row[cellIndex + colspan + 1] === cellID) )
						delete row[cellIndex + colspan++ + 1];
					while ( (rowIndex + rowspan + 1 < workTable.length) && (workTable[rowIndex + rowspan + 1][cellIndex] === cellID) )
						delete workTable[rowIndex + rowspan++ + 1][cellIndex];
					if ( colspan > 0 ) htmlCell.attr('colspan', colspan + 1);
					if ( rowspan > 0 ) htmlCell.attr('rowspan', rowspan + 1);
				}
			}
		}

		return htmlTable;
	};

	this.splitCellsTableTemoinseGuide = function() {
		var referenceCellID;
		var referenceRow;
		var currentCellID;
		for ( var rowIndex = 0; rowIndex < this.table.length; rowIndex++ ) {
			var row = this.table[rowIndex];
			if ( referenceCellID === row[0] ) {
				var currentOutputClass = this.getListeOutputclass(row).sort();
				var referenceOutputClass = this.getListeOutputclass(referenceRow).sort();
				if ( ! currentOutputClass.equals(referenceOutputClass) ) {
					currentCellID = this.storeCell(this.currentID++, this.getRawCell(referenceCellID)[0]);
					referenceRow = row;
				}
				row[0] = currentCellID;
			} else {
				referenceRow = row;
				referenceCellID = referenceRow[0];
				currentCellID = referenceRow[0];
			}
		}
	}

	this.htmlTableTemoinseGuide = function(pathToDoc) {
		this.splitCellsTableTemoinseGuide();
		var htmlTable = $("<table/>").append("tbody");
		var workTable = this.arrayClone(this.table);
		for ( var rowIndex = 0; rowIndex < workTable.length; rowIndex++ ) {
			var row = workTable[rowIndex];
			var htmlRow = $("<tr/>");
			htmlTable.append(htmlRow);
			for ( var cellIndex = 0; cellIndex < row.length; cellIndex++ ) {
				var cellID = row[cellIndex];
				if ( cellID !== undefined ) {
					var htmlCell = $("<td/>");
					htmlRow.append(htmlCell);
					var cellContent = this.getCellContent(cellID);
					if ( cellIndex == 0 ) {
						var images = $(cellContent).find('tablejs__image').addBack('tablejs__image'); // bug Firefox !
						listeOutputclass = this.getListeOutputclass(row);
						for ( var indexImage = 0; indexImage < $(images).length; indexImage++ ) {
							$(images.get(indexImage)).replaceWith(this.htmlPictoTemoineGuide($(images).get(indexImage), $(images).length, listeOutputclass, pathToDoc));
						}
					}
					htmlCell.append(cellContent);
					var colspan = 0;
					var rowspan = 0;
					while ( (cellIndex + colspan + 1 < row.length) && (row[cellIndex + colspan + 1] === cellID) )
						delete row[cellIndex + colspan++ + 1];
					while ( (rowIndex + rowspan + 1 < workTable.length) && (workTable[rowIndex + rowspan + 1][cellIndex] === cellID) )
						delete workTable[rowIndex + rowspan++ + 1][cellIndex];
					if ( colspan > 0 ) htmlCell.attr('colspan', colspan + 1);
					if ( rowspan > 0 ) htmlCell.attr('rowspan', rowspan + 1);
				}
			}
		}

		return htmlTable;
	};

	this.getClassClignotant = function(imageOutputclass, nbTemoins, listeOutputclass) {
		var classClignotant;
		if ( imageOutputclass !== undefined ) { imageOutputclass = imageOutputclass.split(" ") } else { imageOutputclass = [] };

		if ( nbTemoins === 1 ) {
			for ( var typeClignotant in this.stylesList ) {
				if ( imageOutputclass.indexOf(typeClignotant) >= 0 ) {
					classClignotant = this.stylesList[typeClignotant];
					break;
				}
			}
			if ( classClignotant === undefined ) {
				for ( var index in listeOutputclass ) {
					if ( listeOutputclass.hasOwnProperty(index) ) {
						var typeClignotantClass = listeOutputclass[index];
					if ( this.stylesList[typeClignotantClass] !== undefined ) {
						classClignotant = this.stylesList[typeClignotantClass];
						break;
						}
					}
				}
			}
		} else {
			for ( var typeClignotantStyleList in this.stylesList ) {
				if ( this.stylesList.hasOwnProperty(typeClignotantStyleList) ) {
					if ( (imageOutputclass.indexOf(typeClignotantStyleList) >= 0) && (listeOutputclass.indexOf(typeClignotantStyleList) >= 0) ) {
					classClignotant = this.stylesList[typeClignotantStyleList];
					break;
					}
				}
			}
		}

		return classClignotant;
	};

	this.htmlPictoTemoineGuide = function(image, nbTemoins, listeOutputclass, pathToDoc) {
		var img = $('<img/>').attr('src', pathToDoc + 'data-images/' + $(image).attr('href')).attr('data-at2x', pathToDoc + 'data-images-2x/' + $(image).attr('href'));
		var classClignotant = this.getClassClignotant($(image).attr('outputclass'), nbTemoins, listeOutputclass);
		if ( classClignotant !== undefined ) {
			var currentClass = img.attr('class');
			if ( currentClass === undefined ) { currentClass = "" } else { currentClass += " " };
			img.attr('class', currentClass + classClignotant);
		}

		return img;
	}

	this.htmlPictoTemoin = function(image, nbTemoins, listeOutputclass, pathToDoc) {
		var temoin = $('<span class="temoin"><span class="wrap"><span class="visuel"/></span></span>');
		var img = $('<img/>').attr('src', pathToDoc + 'data-images/' + $(image).attr('href')).attr('data-at2x', pathToDoc + 'data-images-2x/' + $(image).attr('href'));
		temoin.find('.visuel').append(img);

		var classClignotant = this.getClassClignotant($(image).attr('outputclass'), nbTemoins, listeOutputclass);
		if ( classClignotant !== undefined ) {
			temoin.attr('class', temoin.attr('class') + " " + classClignotant);
		}

		return temoin;
	}

	this.getListeOutputclass = function(row) {
		function extractClass(index, element) {
			var listeOutputclassElement = $(element).attr('outputclass').split(" ");
			for (var outputclassIndex in listeOutputclassElement) {
				if ( listeOutputclassElement.hasOwnProperty(outputclassIndex) ) {
					var outputclass = listeOutputclassElement[outputclassIndex];
					if ( (outputclass.indexOf("style_img-cligno-") === 0) && (listeOutputclass.indexOf(outputclass) < 0) ) listeOutputclass.push(outputclass);
				}
			}
		}

		var usefullCols = row.slice(1);
		var listeOutputclass = [];
		for ( var entryIDindex in usefullCols ) {
			if ( usefullCols.hasOwnProperty(entryIDindex) ) {
				var entryID = usefullCols[entryIDindex];
				var entry = $(this.getRawCell(entryID)).find('[outputclass]').addBack('[outputclass]');
				entry.each(extractClass);
			}
		}

		return listeOutputclass;
	}

	this.getRawTemoinTitle = function() {
		if ( (this.table.length > 0) && (this.table[0].length > 1) ) {
			return this.getRawCell(this.table[0][1]);
		}
	}

	this.getContentTemoinTitle = function() {
		if ( (this.table.length > 0) && (this.table[0].length > 1) ) {
			return this.getCellContent(this.table[0][1]);
		}
	}

	this.getTextTemoinTitle = function() {
		var title = this.getContentTemoinTitle();
		if ( title !== undefined ) {
			return $(title).text();
		}
		return "";
	}

	this.getTemoinTitle = function() {
		var title = this.getContentTemoinTitle();
		if ( title !== undefined ) {
			return $('<h1 data-role="content-title" id="content-title"/>').append(title);
		}
	}

	this.htmlTemoins = function(pathToDoc, actionTitle) {
		var html = $('<root/>');
		for ( var rowIndex = 0; rowIndex < this.table.length; rowIndex++ ) {
			var row = this.table[rowIndex];
			var etat = $('<div class="etat"/>');
			var description = $('<span class="description"/>');
			etat.append(description);
			var temoins = $('<span class="temoins"/>');
			description.append(temoins);
			var images = $(this.getRawCell(row[0])).find('tablejs__image').addBack('tablejs__image');
			for ( var indexImage = 0; indexImage < images.length; indexImage++ ) {
				temoins.append(this.htmlPictoTemoin(images.get(indexImage), images.length, this.getListeOutputclass(row), pathToDoc));
			}
			description.append(this.getCellText(row[2]));
			html.append(etat);

			var info = $('<div class="info"/>');
			info.append(this.getCellContent(row[3]));
			html.append(info);
			
			var textAction = this.getCellText(row[4]);
			if ( textAction.length > 0 ) {
				var action = $('<div class="action_observation" data-role="block"><h2 data-role="block-title"/><div data-role="block-content"/></div>');
				action.find('[data-role="block-title"]').text(actionTitle);
				action.find('[data-role="block-content"]').append(this.getCellContent(row[4]));
				html.append(action);
			}

		}

		return html.children();
	}


	this.arrayClone = function(arr) {
	    var i, copy;

	    if ( Array.isArray(arr) ) {
	        copy = arr.slice(0);
	        for ( i = 0; i < copy.length; i++ ) {
	            copy[i] = this.arrayClone(copy[i]);
	        }
	        return copy;
	    } else if ( typeof arr === 'object' ) {
	        throw 'Cannot clone array containing an object!';
	    } else {
	        return arr;
    	}
	};

};


// http://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript
// Warn if overriding existing method
if(Array.prototype.equals)
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
    // if the other array is a falsy value, return
    if (!array)
        return false;

    // compare lengths - can save a lot of time 
    if (this.length != array.length)
        return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i]))
                return false;       
        }           
        else if (this[i] != array[i]) { 
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;   
        }           
    }       
    return true;
}
// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});

